import app from './app';
import articles from './articles';
import articlePrices from './articlePrices';
import * as icons from './icons';

/**
 * The application's constants.
 */
export default Object.freeze(
    {
        app,
        articles,
        articlePrices,
        icons,
    }
);
